import { SkipLinksUI } from "./SkipLinksUI";
import { StandardProps } from "../componentMap";
import { ensureIsActive } from "../../utils/product/ensureIsActive";
import { hasAnyStock } from "../../utils/product/hasAnyStock";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { isInStoreOnly } from "../../utils/variant/isInStoreOnly";

export const SkipLinks = ({ product }: Pick<StandardProps, "product">) => {
  const { variant } = useVariant(product);
  if (
    ensureIsActive(product) &&
    !hasAnyStock(product) &&
    product.variants.length === 1 &&
    // @ts-ignore
    !isInStoreOnly(product.variants[0])
  ) {
    return null;
  }

  return (
    <SkipLinksUI
      productType={product.__typename}
      isActive={!!ensureIsActive(product)}
      isInStoreOnly={isInStoreOnly(variant)}
    />
  );
};
